// extracted by css-extract-rspack-plugin
export default {"suggestions":"Suggestions-module__suggestions___hmrG","suggestionButton":"Suggestions-module__suggestionButton__LlVFN"};